"use client";

import styles from "./Dashboard.module.css";
import DashboardCountUp from "./DashboardCountUp";

type Props = {
  label: string;
  value: number;
  total?: number;
};

export default function DashboardStat(props: Props) {
  const { label, value, total } = props;

  return (
    <div className={styles.counter}>
      <span className={styles.counterValue}>
        <DashboardCountUp value={value} />
        {total !== undefined && <span className={styles.counterTotal}>/{total}</span>}
      </span>

      <span className={styles.counterLabel}>{label}</span>
    </div>
  );
}
